module.exports = __webpack_public_path__ + "img/OBCINA RACE-FRAM.a71bc6bf.png";